// extracted by css-extract-rspack-plugin
export default {"cut":"cut-aQSfm","disabledLink":"disabledLink-kJ17f"};